import React from 'react'
import './back-soon.scss'
import hiccupImage from '../../assets/images/tech-hiccup.png'

const BackSoon = () => (
  <div className="main-container">
    <div className="logo-container">
      <div className="logo" />
    </div>
    <h2 className="back-soon-title">Oops! Something went wrong...</h2>
    <div className="back-soon">
      <img src={hiccupImage} alt="Technical Hiccup" id="statusImageContent" />
    </div>
    <p className="back-soon-message">
      Refresh won’t work on this page. Go back to the previous page and try
      again to see if we fixed it.
    </p>
    <div className="button-group">
      <button onClick={() => window.history.back()}>Go back</button>
    </div>
  </div>
)

export default BackSoon



// WEBPACK FOOTER //
// ./scenes/back-soon/index.js